export const ds_TableBlock_Entry = `
    fragment ds_TableBlock_Entry on ds_TableBlock_Entry {
        id
        canonicalUid
        table_ColorPalette
        table_ColorTheme
        table_TopSpacing
        table_ContainerWidth
        table_FullWidthBackground

        table_BgAlternating
        table_BgTitleOnly
        table_Table {
            rows
            columns {
                width
                heading
                align
            }
        }
    }
`